var PathStore = require('../stores/PathStore');

/**
 * Transitions to the previous URL.
 */
function goBack() {
  PathStore.pop();
}

module.exports = goBack;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/modules/helpers/goBack.js
// module id = 211
// module chunks = 0